class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.onFocusOut = this.onFocusOut.bind(this);
    this.onToggle = this.onToggle.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
  }

  connectedCallback() {
    this.mainDetailsToggle = this.querySelector('details');
    if (!this.mainDetailsToggle) return;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut);
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle);
    this.mainDetailsToggle.addEventListener('keyup', this.onKeyUp);
    this.onToggle();
  }

  disconnectedCallback() {
    clearTimeout(this.focusOutTimer);
    this.mainDetailsToggle?.removeEventListener('focusout', this.onFocusOut);
    this.mainDetailsToggle?.removeEventListener('toggle', this.onToggle);
    this.mainDetailsToggle?.removeEventListener('keyup', this.onKeyUp);
  }

  onToggle() {
    this.mainDetailsToggle.querySelector('summary')
      ?.setAttribute('aria-expanded', String(this.mainDetailsToggle.open));
  }

  onKeyUp(event) {
    if (event.defaultPrevented || isComposingEvent(event)) return;
    if (event.key !== 'Escape' && event.code?.toUpperCase() !== 'ESCAPE') return;
    if (!this.mainDetailsToggle?.open) return;
    event.stopPropagation();
    this.close();
    this.mainDetailsToggle.querySelector('summary')?.focus();
  }

  onFocusOut() {
    clearTimeout(this.focusOutTimer);
    this.focusOutTimer = setTimeout(() => {
      if (this.isConnected && !this.contains(document.activeElement)) this.close();
    });
  }

  close() {
    if (!this.mainDetailsToggle) return;
    this.mainDetailsToggle.removeAttribute('open');
    this.onToggle();
  }
}

customElements.define('details-disclosure', DetailsDisclosure);
